module.exports = __webpack_public_path__ + "img/TT.dc4e727b.svg";